import Paginator from './Paginator'

Paginator.install = function install (Vue) {
  Vue.component(Paginator.name, Paginator)
}

export default Paginator



// WEBPACK FOOTER //
// ./src/components/reusable/paginator/index.js